var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,11.3c-1.9,0.5-3,2.5-2.5,4.5l0.4,1.6L13.1,33.6c-0.5-1.4-2-2.2-3.5-1.7c-1.5,0.4-2.4,2-2,3.6l2.2,7.6 c0.4,1.5,2,2.4,3.6,2c1.4-0.4,2.3-1.9,2-3.3l2.4,0.1c-0.2,0.4-0.3,0.8-0.4,1.3c0,0.8,0.2,1.5,0.8,2.1c0.5,0.6,1.2,0.9,2,0.9 l10.8,0.4c0.3,0,0.6,0,0.9-0.1c1.2-0.3,2.1-1.4,2.1-2.7c0-0.3-0.2-0.9-0.4-1.4l11.3,0.3l0.4,1.6c0.5,1.9,2.5,3,4.5,2.5 c1.9-0.5,3-2.5,2.5-4.5l-8.1-28.5C43.7,11.9,41.7,10.8,39.8,11.3L39.8,11.3z M32.6,43.7c0,0.8-0.7,1.4-1.5,1.4l-10.8-0.4 c-0.4,0-0.7-0.2-1-0.5c-0.3-0.3-0.4-0.7-0.4-1c0-0.6,0.4-1.1,1-1.3l11.5,0.3c0.3,0.1,0.7,0.2,0.8,0.4 C32.5,42.9,32.6,43.3,32.6,43.7L32.6,43.7z M32.6,43.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIcon);
export default __webpack_public_path__ + "static/media/messaging_icon.d28e734fccdb5bf3b4928585e3843691.svg";
export { ForwardRef as ReactComponent };